module.exports = __webpack_public_path__ + "img/telegram.2cb215c0.png";